var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-banner"},[_c('div',{staticClass:"bg-overlay"}),_c('div',{staticClass:"container"},[_c('breadcrumb',{staticClass:"breadcrumb",attrs:{"detailTitle":_vm.detailTitle}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }